import React, { useState, useEffect } from "react";
import LocationHeading from "../../../shared/LocationHeading";
import { Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import noData from "../../../assets/Images/NoData.svg";
import copyIcon from "../../../assets/Images/copy.svg";
import DeleteIcon from "../../../assets/Images/delete_icon_red.svg";
import api from "../../../services/api";
import { toast } from "react-toastify";
import Loading from "../../../shared/Loading";
import CustomModal from "../../../shared/CustomModal";

const CouponSetup = () => {
  const [coupons, setCoupons] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [couponToDelete, setCouponToDelete] = useState(null);
  const [totalItems, setTotalItems] = useState(0);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const token = localStorage.getItem("token");

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setPage(newPage);
    }
  };

  const fetchCoupons = async () => {
    setLoading(true);
    try {
      const res = await api.getCoupons(
        { page, perPage: 10, title: search },
        token
      );
      const result = res?.data;
      setCoupons(result?.coupons || []);
      setTotalPages(result?.totalPages || 1);
      setTotalItems(result?.total || 0);
    } catch (error) {
      console.error("Error fetching coupons:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteClick = (coupon) => {
    setCouponToDelete(coupon);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    try {
      const res = await api.deleteCoupon(couponToDelete.id, token);
      if (res?.status) {
        setShowDeleteModal(false);
        toast.success(res?.message || "Coupon deleted successfully");
        fetchCoupons();
      }
    } catch (error) {
      console.error("Delete failed:", error);
      toast.error("Failed to delete coupon");
    } finally {
      setShowDeleteModal(false);
      setCouponToDelete(null);
    }
  };

  const cancelDelete = () => {
    setShowDeleteModal(false);
    setCouponToDelete(null);
  };

  useEffect(() => {
    const delay = setTimeout(() => {
      fetchCoupons();
    }, 500);

    return () => clearTimeout(delay);
  }, [search, page]);

  const handleCopy = (code) => {
    navigator.clipboard.writeText(code);
    toast.success("Copied successfully");
  };

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString("en-GB", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  };
  const handleChange = (e) => {
    console.log(e.target.value);
    setSearch(e.target.value);
  };

  if (loading) {
    return (
      <div className="overlay">
        <Loading />
      </div>
    );
  }

  return (
    <>
      <div className="location_list">
        <LocationHeading title={"Coupon Setup"} />
        <div className="loaction-list-main">
          <div className="loaction-list-head">
            <div className="search-bar">
              <input
                type="text"
                placeholder="Search by title"
                value={search}
                onChange={handleChange}
              />
              <i className="fa fa-search" aria-hidden="true"></i>
            </div>
            <div className="add-location">
              <button>
                <Link to={"/couponSetup/AddCoupon"}>
                  <i className="fa fa-plus me-2" aria-hidden="true"></i>
                  Add Coupon
                </Link>
              </button>
            </div>
          </div>

          <Table size="lg" className="location_list-table">
            <thead>
              <tr>
                <th>Coupon Title</th>
                <th>Coupon Code</th>
                <th>Coupon Duration</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {coupons.length === 0 ? (
                <tr>
                  <td colSpan="6" className="text-center no_data-image">
                    <img
                      src={noData}
                      alt="No Data"
                      width={"100%"}
                      height="100%"
                    />
                  </td>
                </tr>
              ) : (
                coupons.map((coupon) => (
                  <tr key={coupon?.id}>
                    <td>{coupon?.title}</td>
                    <td>
                      <span className="d-flex gap-2 align-items-center copy-img">
                        {coupon?.couponCode}
                        <img
                          style={{ cursor: "pointer" }}
                          src={copyIcon}
                          alt="Copy"
                          onClick={() => handleCopy(coupon?.couponCode)}
                        />
                      </span>
                    </td>
                    <td>
                      <b style={{ fontWeight: "600", color: "#333333" }}>
                        From:
                      </b>{" "}
                      <span>{formatDate(coupon?.startDate)}</span>
                      <br />
                      <b style={{ fontWeight: "600", color: "#333333" }}>
                        To:
                      </b>{" "}
                      <span>{formatDate(coupon?.endDate)}</span>
                    </td>
                    <td>
                      <button
                        className={`status_button ${
                          coupon.status.toLowerCase() === "active"
                            ? "available"
                            : coupon.status.toLowerCase() === "upcoming"
                            ? "upcoming" // new class
                            : "sold"
                        }`}
                      >
                        {coupon.status}
                      </button>
                    </td>
                    <td>
                      <button
                        className="action-view"
                        onClick={() => handleDeleteClick(coupon)}
                      >
                        <img src={DeleteIcon} alt="Delete" />
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </Table>

          <div className="next-previous-slide">
            <div className="slides-heading">
              <span>
                Showing {(page - 1) * 10 + 1} to{" "}
                {Math.min(page * 10, totalItems)} of {totalItems}
              </span>
            </div>
            <div className="slides-button">
              <ul className="d-flex justify-center align-items-center">
                <li>
                  <button
                    onClick={() => handlePageChange(page - 1)}
                    disabled={page === 1}
                  >
                    <i className="fa fa-angle-left" aria-hidden="true"></i>
                  </button>
                </li>

                {Array.from({ length: totalPages }).map((_, index) => {
                  const pageNum = index + 1;
                  return (
                    <li key={pageNum}>
                      <button
                        onClick={() => handlePageChange(pageNum)}
                        className={page === pageNum ? "active-coupon" : ""}
                      >
                        {pageNum}
                      </button>
                    </li>
                  );
                })}

                <li>
                  <button
                    onClick={() => handlePageChange(page + 1)}
                    disabled={page === totalPages}
                  >
                    <i className="fa fa-angle-right" aria-hidden="true"></i>
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      {showDeleteModal && <div className="overlay"></div>}
      <CustomModal
        isOpen={showDeleteModal}
        onClose={cancelDelete}
        SuccessMessage="Please confirm!"
        ModalMessage="Are you sure you want to delete the coupon?"
        onConfirmDelete={confirmDelete}
      />
    </>
  );
};

export default CouponSetup;
